// extracted by mini-css-extract-plugin
module.exports = {"main":"moreOrderTip_main__x4KyR"};